var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.173 12.5L14.2909 15.4027C14.4303 15.5324 14.5 15.6829 14.5 15.854C14.5 16.0251 14.4303 16.1755 14.2909 16.3053C14.1515 16.4351 13.9899 16.5 13.8061 16.5C13.6223 16.5 13.4607 16.4351 13.3213 16.3053L9.70913 12.9425C9.56971 12.8127 9.5 12.6652 9.5 12.5C9.5 12.3348 9.56971 12.1873 9.70913 12.0575L13.3213 8.69469C13.4607 8.5649 13.6191 8.5 13.7966 8.5C13.974 8.5 14.1324 8.5649 14.2719 8.69469C14.4113 8.82448 14.481 8.97493 14.481 9.14602C14.481 9.31711 14.4113 9.46755 14.2719 9.59735L11.173 12.5Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowLess);
export default __webpack_public_path__ + "static/media/showLess.156a7c1b98d99e680384087b6a6e9779.svg";
export { ForwardRef as ReactComponent };